/**
 * Read the merged store list from the root loader's data.
 *
 * Backed by `getStoresFromCentral()` in app/api/store-central.server.ts —
 * which fetches from Budflow + website_locations, or returns the hardcoded
 * fallback when STORES_FROM_CENTRAL=false / on any error.
 *
 * Use this in client components instead of `import { stores } from '~/constants/stores'`
 * so the data flows from a single source. For server-side code (loaders,
 * actions), call `getStoresFromCentral()` directly.
 */

import { useRouteLoaderData } from '@remix-run/react';
import { stores as HARDCODED_STORES, type Store } from '~/constants/stores';

interface RootLoaderData {
  store: string;
  stores: Store[];
}

export function useStores(): Store[] {
  const data = useRouteLoaderData('root') as RootLoaderData | undefined;
  // Hardcoded fallback is a defensive default — under normal Remix operation
  // the root loader always runs, so data?.stores will be present. This guard
  // matters only if someone uses this hook outside the root layout tree.
  return data?.stores ?? HARDCODED_STORES;
}
